import { DataCard } from '@/reports/shared/DataCard/DataCard';
import { AutomobileTheft } from '@/reports/types/vehicles';
import {
  generateSectionIdentifyingData,
  generateSectionSourceData,
} from '@/reports/vehicle/VehicleReport';
import { Text, Accordion, styled, Table } from '@/theme/index';
import { DateUtil } from '@/utils/dateUtil/dateUtil';
import { formatDateFromReport } from '@/utils/formatDateFromReport/formatDateFromReport';

interface VehicleTheft {
  theft: AutomobileTheft;
}

const StyledAccordion = styled(Accordion)(() => ({
  '.MuiAccordionSummary-content p': {
    fontSize: '20px',
  },
}));

export function VehicleTheftCard({ theft }: VehicleTheft) {
  const dateParser = new DateUtil();

  const formatDate = (dateString: string) => {
    return dateParser.parseDateFromString(dateString, 'MM/dd/yyyy');
  };

  function CardTitleText() {
    return (
      <Text
        variant="h3"
        fontWeight="normal"
        mb={0}
        data-testid="vehicle-thefts-card-title"
      >
        {theft.record_type ? `${theft.record_type} reported` : 'Reported'}
        {theft.date?.full && (
          <>
            <Text variant="h3" fontWeight="normal" component="span">
              {' '}
              on
            </Text>
            <Text variant="h3" component="span">
              {' '}
              {formatDateFromReport(theft.date.full)}
            </Text>
          </>
        )}
        {theft.theft_reported_state && (
          <>
            <Text variant="h3" fontWeight="normal" component="span">
              {' '}
              in
            </Text>
            <Text variant="h3" component="span">
              {' '}
              {theft.theft_reported_state}
            </Text>
          </>
        )}
      </Text>
    );
  }

  const theftGeneralData = [
    ['Date of theft', (theft.date?.full && formatDate(theft.date?.full)) || ''],
    [
      'Date of recovery',
      (theft.date_of_recovery?.full &&
        formatDate(theft.date_of_recovery?.full)) ||
        '',
    ],
  ].filter((value) => Boolean(value[1]));

  const theftIdentifyingData = generateSectionIdentifyingData(theft);
  const generateTheftSourceData = () => {
    const sourceData = generateSectionSourceData(theft);
    theft.report_id && sourceData.unshift(['Report ID', theft.report_id]);

    return sourceData;
  };
  const theftSourceData = generateTheftSourceData();
  const displayGeneralData =
    (theftSourceData.length > 0 || theftIdentifyingData.length > 0) &&
    theftGeneralData.length > 0;

  return (
    <DataCard testId="vehicle-thefts-card" id={theft.id || ''}>
      <CardTitleText />
      {Boolean(theft.status) && (
        <Text fontSize="0.75rem" mt="0" mb="10px">
          Status: {theft.status}
        </Text>
      )}
      {displayGeneralData && (
        <Table
          rows={theftGeneralData}
          data-testid="vehicle-thefts-card-general"
          className="flipped"
        />
      )}
      {theftSourceData.length > 0 && (
        <StyledAccordion display="Source information">
          <Table className="striped flipped" rows={theftSourceData} />
        </StyledAccordion>
      )}
      {theftIdentifyingData.length > 0 && (
        <StyledAccordion display="Indentifying information">
          <Table className="striped flipped" rows={theftIdentifyingData} />
        </StyledAccordion>
      )}
    </DataCard>
  );
}
